

export enum FileStatus {
  Pending = "Pending",
  Reading = "Reading",
  Done = "Done"
}

export default FileStatus;
